import type {PropertyValue, ValueType} from '@github-ui/custom-properties-types'
import {Checkbox, FormControl} from '@primer/react'

import {PropertyValueField} from './PropertyValueField'
import styles from './RequiredDefinitionEditor.module.css'

interface Props {
  checkboxLabel?: string
  checkboxCaption?: string
  defaultValueCaption?: string
  isRequired: boolean
  valueType: ValueType
  defaultValue: PropertyValue
  defaultValueError?: string
  allowableDefaultValues: string[]
  propertyName: string
  onRequiredChange: (required: boolean) => void
  onDefaultValueChange: (value: PropertyValue) => void
  setDefaultValueInputRef?: (ref: HTMLElement | null) => void
  requiredFormExtension?: React.ReactNode
  className?: string
}

export function RequiredDefinitionEditor({
  checkboxLabel = 'Require this property for all targets',
  checkboxCaption = "Targets that don't have an explicit value for this property will inherit the default value.",
  defaultValueCaption = 'This is the default value that will be set for this property.',
  isRequired,
  valueType,
  defaultValue,
  defaultValueError,
  allowableDefaultValues: providedDefaultValues,
  propertyName,
  onRequiredChange,
  onDefaultValueChange,
  setDefaultValueInputRef,
  requiredFormExtension,
  className,
}: Props) {
  return (
    <div className={className}>
      <FormControl>
        <Checkbox checked={isRequired} onChange={() => onRequiredChange(!isRequired)} />
        <FormControl.Label>{checkboxLabel}</FormControl.Label>
        <FormControl.Caption>{checkboxCaption}</FormControl.Caption>
      </FormControl>
      <div className={styles.optionsInputGroup}>
        {isRequired && (
          <>
            <PropertyValueField
              required
              idPrefix="property-default-value"
              className={styles.defaultValueFormControl}
              label="Default value"
              caption={defaultValueCaption}
              propertyName={propertyName}
              setInputRef={setDefaultValueInputRef}
              value={defaultValue}
              onChange={onDefaultValueChange}
              valueType={valueType}
              allowedValues={providedDefaultValues}
              error={defaultValueError}
            />
            {requiredFormExtension}
          </>
        )}
      </div>
    </div>
  )
}
